import { $host } from './index';

// Запросы для работы с врачами
export const postDoctor = async (doctor) => {
  const { data } = await $host.post('web/doctors', doctor);
  return data;
};

export const deleteDoctor = async (doctorId) => {
  const { data } = await $host.post('web/doctors/remove', doctorId);
  return data;
};

export const fetchDoctors = async () => {
  const { data } = await $host.get('web/doctors');
  return data;
};

export const fetchOneDoctor = async (id) => {
  const { data } = await $host.get('web/doctors/' + id);
  return data;
};

export const syncDoctorsFromMIS = async (role) => {
  const { data } = await $host.get('web/doctors/sync', {
    params: { role }
  });
  return data;
};

// Запросы для работы со специализациями
export const postSpecialization = async (specialization) => {
  const { data } = await $host.post('web/specializations', specialization);
  return data;
};

export const getSpecializations = async () => {
  const { data } = await $host.get('web/specializations/update');
  return data;
};

export const fetchSpecializations = async () => {
  const { data } = await $host.get('web/specializations');
  return data;
};

export const deleteSpecialization = async (specialization) => {
  const { data } = await $host.post('web/specializations/remove', specialization);
  return data;
};

export const deleteSpecializationService = async (serviceId) => {
  const { data } = await $host.post('web/specializations/remove-service', { serviceId });
  return data;
};

// Запросы для работы с памятками
export const postPreparationGuide = async (guide) => {
  const { data } = await $host.post('web/preparations', guide);
  return data;
};

export const updatePreparationGuide = async (guide) => {
  const { data } = await $host.put(`web/preparations/${guide.id}`, guide);
  return data;
};

export const getPreparationGuide = async (specializationId) => {
  const { data } = await $host.get(`web/preparations/specialization/${specializationId}`);
  return data;
};

export const deletePreparationGuide = async (guideId) => {
  const { data } = await $host.delete(`web/preparations/${guideId}`);
  return data;
};